export default {
  bot: 'Bot',
  campaign: 'Campanha',
  audit: 'Audiência',
  failed: 'Falharam',
  received: 'Recebidas',
  read: 'Lidas',
  scheduled: 'Agendamento',
  send_date: 'Data do Envio',
  processed: 'Enviadas',
};
